'use es6';

import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StepInterface from './StepInterface';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { FINISH_STEP, POST_SETUP_STEP } from '../../constants/InboxConnectStepKeys';
import { logException } from '../../utils/RavenUtils';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PostSetupStep extends PureComponent {
  constructor(props) {
    super(props);
    this.setInboxAutomation = () => {
      const {
        emailAddress,
        setShownStep,
        selectedAutomation,
        service,
        trackingClient
      } = this.props;
      if (typeof selectedAutomation === 'boolean') {
        const callSucceeded = () => {
          trackingClient.trackStepAction(POST_SETUP_STEP, 'automation-set', {
            value: selectedAutomation.toString()
          });
          setShownStep(FINISH_STEP);
        };
        const callFailed = error => {
          logException(error);
          setShownStep(FINISH_STEP);
        };
        if (service.setEnableAutomation) {
          service.setEnableAutomation(emailAddress, selectedAutomation).then(callSucceeded).catch(callFailed);
          return;
        }
      }
      setShownStep(FINISH_STEP);
    };
    this.state = {
      message: 'InboxConnectUtils.wizard.postSetup.configuringSettings'
    };
  }
  componentDidMount() {
    this.props.trackingClient.trackStepView(POST_SETUP_STEP);
    this.setInboxAutomation();
  }
  render() {
    const {
      message
    } = this.state;
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      blockSize: "100%",
      children: /*#__PURE__*/_jsxs("div", {
        "data-selenium": "post-connect-step",
        children: [/*#__PURE__*/_jsx(LoadingSpinner, {
          grow: true,
          minHeight: 100
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: message
          })
        })]
      })
    });
  }
}
PostSetupStep.propTypes = StepInterface;
export default PostSetupStep;